var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagShopping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 160H344V120C344 53.828 290.172 0 224 0S104 53.828 104 120V160H32C14.326 160 0 174.326 0 192V432C0 476.182 35.816 512 80 512H368C412.184 512 448 476.182 448 432V192C448 174.326 433.674 160 416 160ZM152 120C152 80.297 184.297 48 224 48S296 80.297 296 120V160H152V120ZM128 248C114.75 248 104 237.25 104 224S114.75 200 128 200S152 210.75 152 224S141.25 248 128 248ZM320 248C306.75 248 296 237.25 296 224S306.75 200 320 200S344 210.75 344 224S333.25 248 320 248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagShopping);
export default __webpack_public_path__ + "static/media/bag-shopping.448cb2ef40179257d6f8e9a3ceef8791.svg";
export { ForwardRef as ReactComponent };